class PasHeader extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.hostSection = this.closest('.shopify-section');
    this.hostSection?.classList.add('pas-header-host');
    if (this.classList.contains('pas-header--static')) this.hostSection?.classList.add('pas-header-host--static');
    this.mega = this.querySelector('[data-mega]');
    this.megaTriggers = [...this.querySelectorAll('[data-mega-trigger]')];
    this.drawer = this.querySelector('[data-drawer]');
    this.openButton = this.querySelector('[data-drawer-open]');
    this.closeButtons = [...this.querySelectorAll('[data-drawer-close]')];
    this.lastFocus = null;
    this.closeTimer = 0;
    this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 24);
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.megaTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggleMega());
      trigger.addEventListener('mouseenter', () => this.openMega(trigger));
      trigger.addEventListener('focus', () => this.openMega(trigger));
    });
    this.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));
    this.addEventListener('mouseleave', () => { this.closeTimer = window.setTimeout(() => this.closeMega(), 120); });
    this.openButton?.addEventListener('click', () => this.openDrawer());
    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.closeDrawer()));
    this.addEventListener('keydown', (event) => this.onKeydown(event));
  }
  disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
  openMega(trigger = this.megaTriggers[0]) {
    if (!this.mega) return;
    this.mega.hidden = false;
    requestAnimationFrame(() => this.mega.classList.add('is-open'));
    this.megaTriggers.forEach((item) => item.setAttribute('aria-expanded', String(item === trigger)));
  }
  closeMega() {
    if (!this.mega) return;
    this.mega.classList.remove('is-open');
    this.megaTriggers.forEach((item) => item.setAttribute('aria-expanded', 'false'));
    window.setTimeout(() => { if (!this.mega.classList.contains('is-open')) this.mega.hidden = true; }, 400);
  }
  toggleMega() { this.mega?.classList.contains('is-open') ? this.closeMega() : this.openMega(); }
  openDrawer() {
    if (!this.drawer) return;
    this.lastFocus = document.activeElement;
    this.drawer.hidden = false;
    this.drawer.setAttribute('aria-hidden', 'false');
    this.openButton?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('pas-lock-scroll');
    requestAnimationFrame(() => {
      this.drawer.classList.add('is-open');
      this.drawer.querySelector('.pas-drawer__panel')?.focus();
    });
  }
  closeDrawer() {
    if (!this.drawer || this.drawer.hidden) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.openButton?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('pas-lock-scroll');
    window.setTimeout(() => { if (!this.drawer.classList.contains('is-open')) this.drawer.hidden = true; }, 500);
    this.lastFocus?.focus?.();
  }
  onKeydown(event) {
    if (event.key === 'Escape') { this.closeMega(); this.closeDrawer(); return; }
    if (event.key !== 'Tab' || !this.drawer?.classList.contains('is-open')) return;
    const focusable = [...this.drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}
if (!customElements.get('pas-header')) customElements.define('pas-header', PasHeader);
